module.exports = __webpack_public_path__ + "img/b4.e457b052.png";